export const baseUrl = process.env.REACT_APP_DATALAYER_URL;

export const datalayerUrls = {
    baseUrl: () => baseUrl,

    general: {
        baseUrl: () => `${baseUrl}/general`,
        manufacturers: () => `${datalayerUrls.general.baseUrl()}/manufacturers/`,
        hierarchy: () => `${datalayerUrls.general.baseUrl()}/hierarchy/`
    }
};
